<template>
  <div class="product-info">
    <section>
      <h2>
        {{ $t('product_info_title')}}
      </h2>
      <div class="description">
        <div class="text">
          <i18n tag="p" path="product_info_1">
            <b>{{ $t('freight_intelligence_maritime') }}</b>
            <b>{{ $t('simplify') }}</b>
            <b>{{ $t('streamline') }}</b>
            <b>{{ $t('centralized') }}</b>
          </i18n>
          <i18n tag="p" path="product_info_2">
            <b>{{ $t('freight_intelligence') }}</b>
          </i18n>
        </div>
        <div class="img">
          <img src="/static/img/tool.png" />
        </div>
      </div>
    </section>
    
    <section style="text-align:center" >
      <h2>
        {{ $t('product_info_title_2')}}
      </h2>
      
      <div class="cards">
        <div class="card">
          <span class="fa-stack fa-3x turq">
            <i class="fa fa-circle fa-stack-2x"></i>
            <i class="fa fa-cogs fa-stack-1x  fa-inverse"></i>
          </span>
          <div class="card-title">
            {{ $t('product_card_1_title') }}
          </div>
          <i18n tag="p" path="product_card_1_text">
            <b class="turq">{{ $t('status') }}</b>
            <b class="turq">{{ $t('glance') }}</b>
          </i18n>
        </div>

        <div class="card">
          <span class="fa-stack fa-3x lime-text">
            <i class="fa fa-circle fa-stack-2x"></i>
            <i class="fa fa-envelope fa-stack-1x  fa-inverse"></i>
          </span>
          <div class="card-title">
            {{ $t('product_card_2_title') }}
          </div>
          <i18n tag="p" path="product_card_2_text">
            <b class="lime-text">{{ $t('alarms') }}</b>
            <b class="lime-text">{{ $t('reports') }}</b>
            <b class="lime-text">{{ $t('email') }}</b>
          </i18n>
        </div>

        <div class="card">
          <span class="fa-stack fa-3x grey">
            <i class="fa fa-circle fa-stack-2x"></i>
            <i class="fa fa-lg fa-globe fa-stack-1x  fa-inverse"></i>
          </span>
          <div class="card-title">
            {{ $t('product_card_3_title') }}
          </div>
          <i18n tag="p" path="product_card_3_text">
            <b class="grey">{{ $t('satelital_system') }}</b>
            <b class="grey">{{ $t('reliable') }}</b>
          </i18n>
        </div>
      </div>
      <div style="margin-top: 2em">
        <i18n tag="p" path="product_info_3">
          <b>{{ $t('visibility') }}</b>
          <b>{{ $t('better') }}</b>
        </i18n>
        <i18n tag="p" path="product_info_4">
          <b>{{ $t('smooth') }}</b>
          <b>{{ $t('peace_of_mind') }}</b>
        </i18n>
      </div>
    </section>
  </div>
</template>
<script>
import SailBoatAnimation from '@/components/product/SailBoatAnimation'
export default {
  name: 'product-info',
  components: { SailBoatAnimation },
  props: ['tab', 'subTab']
}
</script>
<style lang="scss" scoped>
.product-info {
  section {
    max-width: 100%;
    width: 70em;
    margin: 3em auto;
    .description {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      .text {
        flex: 6;
        margin-right: 4%;
        min-width: 200px;
      }
      .img {
        flex: 4;
        max-width: 100%;
        margin-left: 4%;
        min-width: 250px;
      }
    }
  }
  .cards{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    .card {
      cursor: default;
      transition: all .3s ease-in-out;
      background: white;
      padding: 1.5em .5em;
      border-radius: .6em;
      display: inline-block;
      box-shadow: 0 .3em .7em rgba(51, 51, 66, 0.3);
      max-width: 100%;
      width: 14em;
      margin: 2em 1em;
      .card-title {
        font-family: MuseoSans-900;
        color: #444;
        margin: .5em 0;
      }
      p{
        margin: .5em;
        font-size: 1rem!important;
      }
      &:hover {
        font-size: 1.1em;
        margin: 0 .25em;
        box-shadow: 0 .4em 1.2em rgba(51, 51, 66, 0.2);
        .fa-stack {
          animation: pulse 2s infinite;
        }
      }
    }
  }
}
@keyframes pulse {
	0% {
		transform: scale(0.97);
	}
	50% {
		transform: scale(1.1);
	}
  100% {
		transform: scale(0.97);
	}
}
</style>


// WEBPACK FOOTER //
// src/components/product/ProductInfo.vue